import * as React from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import { Link } from "react-router-dom";
import { useLocation } from "react-router-dom";

export default function BasicTab() {
  // const [value, setValue] = React.useState(
  //   useLocation().pathname.replace("/SiMS_ReactJS", "")
  // );

  const [value, setValue] = React.useState(0);
  const pathname = useLocation().pathname.replace("/SiMS_ReactJS", "");

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Box sx={{ width: "100%" }}>
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs
          value={pathname}
          onChange={handleChange}
          aria-label="basic tabs example"
        >
          <Tab
            label="User Administration"
            sx={{ textTransform: "none" }}
            component={Link}
            to="user_admin"
            value={"/admin/user_admin"}
          />

          <Tab
            label="Group Scenario Activity"
            sx={{ textTransform: "none" }}
            component={Link}
            to="Group_Scenario_Activity"
            value={"/admin/Group_Scenario_Activity"}
          />
          <Tab
            label="Approval Level"
            sx={{ textTransform: "none" }}
            component={Link}
            to="approval"
            value={"/admin/approval"}
          />

          <Tab
            label="SKU Replacement"
            sx={{ textTransform: "none" }}
            component={Link}
            to="SKU_Replacement"
            value={"/admin/SKU_Replacement"}
          />

          <Tab
            label="Edit UOM"
            sx={{ textTransform: "none" }}
            component={Link}
            to="Edit_UOM"
            value={"/admin/Edit_UOM"}
          />

          <Tab
            label="Record Modification"
            sx={{ textTransform: "none" }}
            component={Link}
            to="Record_Modification"
            value={"/admin/Record_Modification"}
          />
          {/* <Tab
            label="Edit Scenario"
            sx={{ textTransform: "none" }}
            component={Link}
            to="Edit_Scenario"
            value={"/admin/Edit_Scenario"}
          /> */}
        </Tabs>
      </Box>
    </Box>
  );
}
